import React from 'react';
import { WingoPrediction } from './components/WingoPrediction';
import { motion } from 'framer-motion';
export function App() {
  return <motion.div className="w-full min-h-screen cyber-bg text-green-400 p-4 flex justify-center items-center grid-bg" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} data-id="element-0">
      <WingoPrediction data-id="element-1" />
    </motion.div>;
}